import {Injectable} from '@angular/core';
import {AdminService} from '../../../../services/admin.service';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class ReviewSuggestionListsService {

  private isCurrentUserHead = false;
  private isCurrentUserInitiator = false;
  private isCurrentUserMember = false;
  private openedSLID = null;
  private allDivisions: any[] = [];

  constructor() {
  }


  getIsCurrentUserHead(): boolean {
    return this.isCurrentUserHead;
  }

  setIsCurrentUserHead(value: boolean) {
    this.isCurrentUserHead = value;
  }

  getIsCurrentUserInitiator(): boolean {
    return this.isCurrentUserInitiator;
  }

  setIsCurrentUserInitiator(value: boolean) {
    this.isCurrentUserInitiator = value;
  }

  getIsCurrentUserMember(): boolean {
    return this.isCurrentUserMember;
  }

  setIsCurrentUserMember(value: boolean) {
    this.isCurrentUserMember = value;
  }

  setAllDivisions(divisionsList) {
    this.allDivisions = divisionsList;
  }

  getAllDivisions() {
    return this.allDivisions;
  }

  clearAllDivisions() {
    this.allDivisions = [];
  }

  setOpenedSLID(oSLId) {
    this.openedSLID = oSLId;
  }

  getOpenedSLID() {
    return this.openedSLID;
  }

  clearOpenedSLID() {
    this.openedSLID = null;
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/suggestion-lists/services/review-suggestion-lists.service.ts